:host {
  display: inline-flex;
  border-radius: 50%;
  overflow: hidden;
  color: var(--theme-primary-background);
  background-color: var(--aha-gray-500);
  vertical-align: middle;
  text-align: center;
  /* You cannot copy the text when it is shown so we don't want to show the pipe cursor */
  cursor: default;

  /* The line-height messes everything up if they give a large label.
   * We just shouldn't support multi line labels. */
  white-space: nowrap;

  /* Default is same as size 18 */
  width: 18px;
  height: 18px;
  border: 1px solid var(--theme-primary-background);
  font-size: 9px;

  align-items: center;
  justify-content: center;
}

:host([size='14']) {
  width: 14px;
  height: 14px;
  border: 1px solid var(--theme-primary-background);
  font-size: 7px;
}
:host([size='16']) {
  width: 16px;
  height: 16px;
  border: 1px solid var(--theme-primary-background);
  font-size: 7px;
}
:host([size='18']) {
  width: 18px;
  height: 18px;
  border: 1px solid var(--theme-primary-background);
  font-size: 9px;
}
:host([size='20']) {
  width: 20px;
  height: 20px;
  border: 2px solid var(--theme-primary-background);
  font-size: 10px;
}
:host([size='24']) {
  width: 24px;
  height: 24px;
  border: 2px solid var(--theme-primary-background);
  font-size: 11px;
}
:host([size='26']) {
  width: 26px;
  height: 26px;
  border: 2px solid var(--theme-primary-background);
  font-size: 11px;
}
:host([size='28']) {
  width: 28px;
  height: 28px;
  border: 2px solid var(--theme-primary-background);
  font-size: 12px;
}
:host([size='32']) {
  width: 32px;
  height: 32px;
  border: 2px solid var(--theme-primary-background);
  font-size: 12px;
}
:host([size='40']) {
  width: 40px;
  height: 40px;
  border: 2px solid var(--theme-primary-background);
  font-size: 14px;
}
:host([size='80']) {
  width: 80px;
  height: 80px;
  border: 2px solid var(--theme-primary-background);
  font-size: 32px;
}
:host([size='160']) {
  width: 160px;
  height: 160px;
  border: 2px solid var(--theme-primary-background);
  font-size: 64px;
}

:host([borderless]) {
  border: none;
}

img {
  width: 100%;
  border-radius: 50%;
  vertical-align: top;
}
